import EnumDataSource from "../utils/enum-data-source.util";

const titles = {
  "1": "Dr.",
  "2": "Mr.",
  "3": "Mrs.",
  "4": "Ms.",
};

const TITLES = new EnumDataSource(titles);

export default TITLES;
